<mat-form-field class="language-button">
  <mat-select (valueChange)="changeLanguage($event)" [value]="currentLanguage">
    <mat-option value="fr" style="padding:6px; font-size:14px;"><div style="margin-right:0px;">FR</div></mat-option>
    <mat-option value="en" style="padding:6px; font-size:14px;"><div>EN</div></mat-option>
  </mat-select>
</mat-form-field>
